/**
 * Canonical placeholder key identifiers. Authors type one of these strings into
 * a placeholder's `placeholderKey` field in the editor inspector; the render
 * page's resolver swaps the placeholder for the matching value at export time.
 *
 * Values are stable identifiers — renaming a value breaks every board that
 * already stored that key. Add new members; do not rename existing ones.
 */
export const PlaceholderKey = {
  TEAM_NAME: 'team_name',
  TEAM_SHORT_NAME: 'team_short_name',
  TEAM_LOGO: 'team_logo',
  SCORE: 'score',
  SCORE_TEAM: 'score_team',
  CHAMPIONSHIP_NAME: 'championship_name',
  TOURNAMENT_NAME: 'tournament_name',
  TOURNAMENT_LOGO: 'tournament_logo',
  MATCH_DATE: 'match_date',
  MATCH_TIME: 'match_time',
  MATCH_VENUE: 'match_venue',
  ROUND_NAME: 'round_name',
  PLAYER_NAME: 'player_name',
  PLAYER_NUMBER: 'player_number',
  PLAYER_PHOTO: 'player_photo',
} as const;

export type PlaceholderKey = (typeof PlaceholderKey)[keyof typeof PlaceholderKey];

const KNOWN_KEYS: ReadonlySet<string> = new Set(Object.values(PlaceholderKey));

export function isKnownPlaceholderKey(value: string | undefined | null): value is PlaceholderKey {
  return typeof value === 'string' && KNOWN_KEYS.has(value);
}
